export default __webpack_public_path__ + "static/146-min-min-187ce8b036f1895bbf8a4e35f2ce330b.jpg";